var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 1.3335H5.49992C3.19909 1.3335 1.33325 3.19933 1.33325 5.50016V10.5002C1.33325 12.801 3.19909 14.6668 5.49992 14.6668H10.4999C12.8007 14.6668 14.6666 12.801 14.6666 10.5002V5.50016C14.6666 3.19933 12.8007 1.3335 10.4999 1.3335ZM13.4166 10.5002C13.4166 12.1085 12.1083 13.4168 10.4999 13.4168H5.49992C3.89159 13.4168 2.58325 12.1085 2.58325 10.5002V5.50016C2.58325 3.89183 3.89159 2.5835 5.49992 2.5835H10.4999C12.1083 2.5835 13.4166 3.89183 13.4166 5.50016V10.5002Z",
    fill: "#E5E8EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 4.6665C6.15925 4.6665 4.66675 6.159 4.66675 7.99984C4.66675 9.8407 6.15925 11.3332 8.00008 11.3332C9.84095 11.3332 11.3334 9.8407 11.3334 7.99984C11.3334 6.159 9.84095 4.6665 8.00008 4.6665ZM8.00008 10.0832C6.85175 10.0832 5.91675 9.14817 5.91675 7.99984C5.91675 6.8507 6.85175 5.9165 8.00008 5.9165C9.14841 5.9165 10.0834 6.8507 10.0834 7.99984C10.0834 9.14817 9.14841 10.0832 8.00008 10.0832Z",
    fill: "#E5E8EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5833 4.86099C11.8286 4.86099 12.0275 4.66213 12.0275 4.41682C12.0275 4.17152 11.8286 3.97266 11.5833 3.97266C11.338 3.97266 11.1392 4.17152 11.1392 4.41682C11.1392 4.66213 11.338 4.86099 11.5833 4.86099Z",
    fill: "#E5E8EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.079443a584e6642d71cd12d3fa991b54.svg";
export { ForwardRef as ReactComponent };